import InteriorDesignForm from "../component/InteriorDesignForm";

const CommercialInteriorDesignEdit = () => {
  return <InteriorDesignForm isEditMode={true} />;
};

export default CommercialInteriorDesignEdit;
